import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CardComponent } from './components/card/card.component';
import { ModalComponent } from './components/modal/modal.component';
import { TextareaDirective } from './directives/textarea/textarea.directive';
import { IconComponent } from './components/icon/icon.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DropdownCreditsComponent } from './components/dropdown-credits/dropdown-credits.component';
import { RadioCreditTypesComponent } from './components/radio-credit-types/radio-credit-types.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorMsgComponent } from './components/validation-error-msg/validation-error-msg.component';
import { ControlValidatorDirective } from './directives/validator.directive';
import { AtlasToastComponent } from './components/atlas-toast/atlas-toast.component';
import { ToastrModule, ToastContainerDirective } from 'ngx-toastr';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ConfirmTabSwitchComponent } from './components/confirm-tab-switch/confirm-tab-switch.component';
import { AtlasButtonComponent } from './components/atlas-button/atlas-button.component';
import { AtlasGridComponent } from './components/atlas-grid/atlas-grid.component';
import { AgGridModule } from 'ag-grid-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonRendererComponent } from './components/atlas-grid/renderer/button-renderer.component';
import { ButtonGroupRendererComponent } from './components/atlas-grid/renderer/buttongroup-renderer.component';
import { AtlasGridPriceRendererComponent } from './components/atlas-grid/renderer/price-renderer.component';
import { AtlasGridHtmlRendererComponent } from './components/atlas-grid/renderer/html-renderer.component';
import { AtlasGridIconRendererComponent } from './components/atlas-grid/renderer/icon-renderer.component';
import { AtlasGridTranslateRendererComponent } from './components/atlas-grid/renderer/translate-renderer.component';
import { SelectfilterRendererComponent } from './components/atlas-grid/renderer/selectfilter-renderer.component';
import { SelectfilterPriorityRendererComponent } from './components/atlas-grid/renderer/selectfilter-priority-renderer.component';
import { InputfilterRendererComponent } from './components/atlas-grid/renderer/inputfilter-renderer.component';
import { GridHeaderSelectComponent } from './components/atlas-grid/renderer/grid-header-select.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { MonthPickerRangeComponent } from './components/month-picker-range/month-picker-range.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SlideToggleComponent } from './components/slide-toggle/slide-toggle.component';
import { CommonModule, DecimalPipe } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgSelectModule } from '@ng-select/ng-select';
import { AtlasInputPhoneComponent } from './components/atlas-inputphone/atlas-inputphone.component';
import { AtlasCollapseComponent } from './components/atlas-collapse/atlas-collapse.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { AtlasDropdownComponent } from './components/atlas-dropdown/atlas-dropdown.component';
import { CustomNoRowsOverlayComponent } from '@ui/components/atlas-grid/overlay/custom-no-rows-overlay.component';
import { DragDropDirective } from './directives/dragdrop.directive';
import { AtlasStepComponent } from '@ui/components/atlas-step/atlas-step.component';
import { CheckboxCellComponent } from './components/atlas-grid/renderer/checkbox-cell-renderer.component';
import { GridSlideToggleComponent } from './components/grid-slide-toggle/grid-slide-toggle.component';
import { TransferCreditsModalComponent } from './components/modal/transfer-credits-modal/transfer-credits-modal.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { InsertTemplateModalComponent } from '@modules/sms/templates/insert-tamplate-modal/insert-tamplate-modal.component';
import { SendingSummuryModalComponent } from '@modules/sms/components/sending-summary/sending-summary-modal.component';
import { LandingPageModalComponent } from '@modules/sms/components/landing-page-modal/landing-page-modal.component';
import { DndZoneComponent } from './dnd-zone/dnd-zone.component';
import { FieldsAssociationsModalComponent } from '@modules/sms/components/fields-assocaitions/fields-assocaitions-modal.component';
import { SmsDetailRenderComponent } from './components/atlas-grid/renderer/sms-detail-render/sms-detail-render.component';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ClickStopPropagationDirective } from './directives/clickStopPropagation.directive';
import { PagePublishModalComponent } from './components/modal/pages-publish-modal/page-publish-modal.component';
import { PagePreviewModalComponent } from './components/modal/pages-preview-modal/page-preview-modal.component';
import { EmailDnsVerifyConfigModalComponent } from './components/modal/email-dns-vconfig-modal/email-dns-verify-config-modal.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { EmailDnsNewModalComponent } from './components/modal/email-dns-new-modal/email-dns-new-modal.component';
import { EmailAddSenderModalComponent } from './components/modal/email-add-sender-modal/email-add-sender-modal.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { PartnerPaymentModalComponent } from './components/modal/partner-payment-modal/partner-payment-modal.component';
import { SmsAdvDetailsModalComponent } from './components/modal/sms-adv-details-modal/sms-adv-details-modal.component';
import { FilterCreditsTypePipe } from './components/dropdown-credits/filter-credits-type/filter-credits-type.pipe';
import { AtlasDatepickerComponent } from './components/atlas-datepicker/atlas-datepicker.component';
import { AtlasDatepickerMonthComponent } from './components/atlas-datepicker/month/atlas-datepicker-month.component';
import { AtlasDatepickerOnlyMonthsComponent } from './components/atlas-datepicker/only-months/atlas-datepicker-only-months.component';
import { AtlasDatepickerOnlyYearComponent } from './components/atlas-datepicker/only-year/atlas-datepicker-only-year.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PreventMultipleClicksDirective } from './directives/preventMultipleClicks.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

const uiComponents = [
  CardComponent,
  ModalComponent,
  TransferCreditsModalComponent,
  InsertTemplateModalComponent,
  SendingSummuryModalComponent,
  FieldsAssociationsModalComponent,
  LandingPageModalComponent,
  IconComponent,
  CheckboxComponent,
  DropdownCreditsComponent,
  RadioCreditTypesComponent,
  AppHeaderComponent,
  AtlasButtonComponent,
  AtlasGridComponent,
  AtlasStepComponent,
  AtlasDatepickerComponent,
  DndZoneComponent,
  AtlasInputPhoneComponent,
  PagePublishModalComponent,
  PagePreviewModalComponent,
  EmailDnsVerifyConfigModalComponent,
  EmailDnsNewModalComponent,
  EmailAddSenderModalComponent,
  PartnerPaymentModalComponent
];

const uiDirectives = [TextareaDirective, DragDropDirective];

@NgModule({
  declarations: [
    ...uiComponents,
    ...uiDirectives,
    ValidationErrorMsgComponent,
    ControlValidatorDirective,
    ClickStopPropagationDirective,
    PreventMultipleClicksDirective,
    ChangePasswordComponent,
    AtlasToastComponent,
    AtlasStepComponent,
    RadioCreditTypesComponent,
    ConfirmTabSwitchComponent,
    ModalComponent,
    TransferCreditsModalComponent,
    InsertTemplateModalComponent,
    SendingSummuryModalComponent,
    FieldsAssociationsModalComponent,
    LandingPageModalComponent,
    CustomNoRowsOverlayComponent,
    ButtonRendererComponent,
    ButtonGroupRendererComponent,
    SmsDetailRenderComponent,
    AtlasGridPriceRendererComponent,
    AtlasGridHtmlRendererComponent,
    AtlasGridIconRendererComponent,
    SelectfilterRendererComponent,
    SelectfilterPriorityRendererComponent,
    InputfilterRendererComponent,
    AtlasGridTranslateRendererComponent,
    GridHeaderSelectComponent,
    CheckboxCellComponent,
    AtlasDatepickerComponent,
    DndZoneComponent,
    AtlasInputPhoneComponent,
    MonthPickerComponent,
    MonthPickerComponent,
    MonthPickerRangeComponent,
    SlideToggleComponent,
    GridSlideToggleComponent,
    AtlasCollapseComponent,
    TruncatePipe,
    SearchInputComponent,
    AtlasDropdownComponent,
    AtlasDatepickerMonthComponent,
    DndZoneComponent,
    AtlasDatepickerOnlyYearComponent,
    AtlasDatepickerOnlyMonthsComponent,
    SmsDetailRenderComponent,
    PagePublishModalComponent,
    PagePreviewModalComponent,
    EmailDnsVerifyConfigModalComponent,
    EmailAddSenderModalComponent,
    PartnerPaymentModalComponent,
    SmsAdvDetailsModalComponent,
    FilterCreditsTypePipe
  ],
  exports: [
    ...uiComponents,
    ...uiDirectives,
    FormsModule,
    ValidationErrorMsgComponent,
    ControlValidatorDirective,
    ClickStopPropagationDirective,
    PreventMultipleClicksDirective,
    ModalComponent,
    TransferCreditsModalComponent,
    InsertTemplateModalComponent,
    SendingSummuryModalComponent,
    FieldsAssociationsModalComponent,
    LandingPageModalComponent,
    CustomNoRowsOverlayComponent,
    ButtonRendererComponent,
    ButtonGroupRendererComponent,
    SmsDetailRenderComponent,
    ClipboardModule,
    MonthPickerComponent,
    MonthPickerRangeComponent,
    SlideToggleComponent,
    GridSlideToggleComponent,
    AtlasCollapseComponent,
    // NgxChartsModule,
    TruncatePipe,
    SearchInputComponent,
    AtlasDropdownComponent,
    PagePublishModalComponent,
    EmailDnsVerifyConfigModalComponent,
    EmailDnsNewModalComponent,
    EmailAddSenderModalComponent,
    NgxSliderModule,
    PartnerPaymentModalComponent,
    SmsAdvDetailsModalComponent,
    NgbModule,
    PickerModule,
    MatProgressSpinnerModule,
    PartnerPaymentModalComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    ToastContainerDirective,
    ToastrModule
  ],
  imports: [
    FormsModule,
    NgbModule,
    FontAwesomeModule,
    InlineSVGModule.forRoot(),
    TranslateModule,
    RouterModule,
    ToastrModule.forRoot({
      toastComponent: AtlasToastComponent
    }),
    ToastContainerDirective,
    ReactiveFormsModule,
    AgGridModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatIconModule,
    DragDropModule,
    NgSelectModule,
    CommonModule,
    ClipboardModule,
    PickerModule,
    NgxSliderModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [DecimalPipe, provideNgxMask()]
})
export class UiModule {}
